import script from "./PassInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PassInput.vue?vue&type=script&setup=true&lang=js"

import "./PassInput.vue?vue&type=style&index=0&id=331e4a5b&lang=scss"

const __exports__ = script;

export default __exports__